<template>
    <div class="form-group">
        <label class="col-4 control-label">
            Variants
        </label>
        <div class="col-8">
            <div class="d-flex mb-3" v-for="(variant, index) in variants" :key="index">
                <div class="mr-3">
                    <input type="text" v-model="variant.name" class="form-control" placeholder="Variant name">
                    <input type="hidden" :name="`${getInputName(variant, index)}[name]`" v-model="variant.name">
                </div>
                <div class="mr-3">
                    <input type="text" v-model="variant.sku" class="form-control" placeholder="SKU">
                    <input type="hidden" :name="`${getInputName(variant, index)}[sku]`" v-model="variant.sku">
                </div>
                <div class="mr-3">
                    <input type="text" v-model="variant.unit_cost" class="form-control" placeholder="Unit cost">
                    <input type="hidden" :name="`${getInputName(variant, index)}[unit_cost]`" v-model="variant.unit_cost">
                </div>
                <div v-if="variant.image_url" class="w-25 mr-3">
                    <img :src="variant.image_url" alt="" class="img-thumbnail img-fluid">
                </div>
                <div class="">
                    <button class="btn btn-danger" type="button" @click="removeVariant(index)"><i class="fa fa-times"></i></button>
                </div>
            </div>
            <button class="btn btn-default" type="button" @click="addVariant">Add variant</button>
        </div>
        <input v-for="(variant, index) in deletedVariants" :key="index" type="hidden" name="deleted_variants[]" :value="variant.id">
    </div>
</template>

<script>
export default {
    props: {
        initialVariants: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            variants: [],
            deletedVariants: [],
        };
    },
    mounted() {
        this.variants = this.initialVariants;
    },
    methods: {
        addVariant() {
            this.variants.push({
                id: null,
                name: null,
            });
        },
        getInputName(variant, index) {
            if (variant.id) {
                return `variants[${variant.id}]`;
            }

            return `new_variants[${index}]`;
        },
        removeVariant(index) {
            this.deletedVariants.push(...this.variants.splice(index, 1));
        },
    },
};
</script>

<style scoped>

</style>